import { render, staticRenderFns } from "./PracticeRegistrant.vue?vue&type=template&id=5d8de725&"
import script from "./PracticeRegistrant.vue?vue&type=script&lang=js&"
export * from "./PracticeRegistrant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports